import { useContext, useState } from "react";
import UserContext from "@contexts/UserContext";
import SupplierContext from "@contexts/SupplierContext";
import ICatalog_Item from "@models/ICatalog_Item";
import OwS3ImageViewer from "@components/shared/OwS3ImageViewer/OwS3ImageViewer";
import IImageSizeEnum from "@models/IImageSizeEnum";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwButton from "@components/shared/OwButton/OwButton";
import IOrder from "@models/IOrder";
import Modal from "react-modal";
import { ProductGroupExtendedSelectionModal } from "../ProductGroupExtendedSelectionModal/ProductGroupExtendedSelectionModal";
import IErrorDTO from "@models/DTO/IErrorDTO";
import IWarehouse from "@models/IWarehouse";
import IProductGroupSelection from "@models/IProductGroupSelection";
import { Socket } from "socket.io-client";
import { IAddBulkItems } from "@models/IAddBulkItems";

type Props = {
    catalogItem: ICatalog_Item;
    order: IOrder;
    addBulkItems?: (items: IAddBulkItems[]) => void;
    addToCart?: (items: IAddBulkItems[]) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    warehouses: IWarehouse[];
    inSidebarViewer?: boolean;
};

export const ProductGroupExtendedSelection = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [selections, setSelections] = useState<IProductGroupSelection[]>([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalComponent, setModalComponent] = useState<any>(null);

    const closeModal = () => {
        setModalIsOpen(false);
        setModalComponent(null);
    };

    const setItemSelections = (_selections: IProductGroupSelection[]) => {
        setSelections(_selections);
        closeModal();
    };

    const openModal = () => {
        const component = (
            <ProductGroupExtendedSelectionModal
                closeModalFn={closeModal}
                socket={props.socket}
                notifyFn={props.notifyFn}
                order={props.order}
                catalogItem={props.catalogItem}
                warehouses={props.warehouses}
                setSelections={setItemSelections}
                addBulkItems={props.addBulkItems}
                addToCart={props.addToCart}
            />
        );

        setModalComponent(component);
        setModalIsOpen(true);
    };

    return (
        <div className={"ProductGroupExtendedSelection"} style={props.inSidebarViewer ? { gridTemplateColumns: "1fr" } : {}}>
            <div className={"SelectionsDiv"}>
                <div>
                    <OwLabel title={"product_group_selections"} className={"me-2"} postText={":"} />
                </div>
                <div className={"SelectionBtnDiv"}>
                    <OwButton title={"select"} fn={openModal} className={"btn-danger"} />
                </div>
            </div>

            <div className={"ParentDetailsDiv"}>
                {props.inSidebarViewer ? null : (
                    <div className={"me-2"}>
                        <OwS3ImageViewer
                            imageSeq={0}
                            catalogItem={props.catalogItem}
                            imageIndex={IImageSizeEnum.THUMB}
                            includeAllImages={true}
                            isMicroView={true}
                        />
                    </div>
                )}

                {props.inSidebarViewer ? null : (
                    <div>
                        <div>
                            <OwLabel title={"name"} className={"me-2 mb-2"} postText={":"} />
                            {props.catalogItem.name}
                        </div>
                        <div>
                            <OwLabel title={"sku"} className={"me-2 mb-2"} postText={":"} />
                            {props.catalogItem.sku}
                        </div>
                        <div>
                            <OwLabel title={"description"} postText={":"} />
                            <div dangerouslySetInnerHTML={{ __html: props.catalogItem.description || "" }}></div>
                        </div>
                    </div>
                )}
            </div>

            <div>
                <Modal
                    isOpen={modalIsOpen}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    className={"modalContentClass h-100"}
                    overlayClassName={"modalOverlayClass"}
                    style={{}}>
                    {modalComponent}
                </Modal>
            </div>
        </div>
    );
};
